import { InferSelectModel } from 'drizzle-orm';
import {
	index,
	pgTable,
	serial,
	timestamp,
	unique,
	varchar,
} from 'drizzle-orm/pg-core';
import { sql } from 'drizzle-orm';

import { createPubkeyField } from './utils';

/**
 * This table stores custom feature flag overrides per authority.
 * Each authority can have multiple feature flags enabled that override
 * the default PostHog feature flag behavior.
 */
export const feature_flag_overrides = pgTable(
	'feature_flag_overrides',
	{
		id: serial('id').primaryKey(),

		authority: createPubkeyField('authority').notNull(),

		enabledFlags: varchar('enabledFlags', { length: 100 })
			.array()
			.notNull()
			.default(sql`ARRAY[]::varchar[]`),

		insertedTime: timestamp('insertedTime', { withTimezone: true })
			.notNull()
			.defaultNow(),

		updatedTime: timestamp('updatedTime', { withTimezone: true })
			.notNull()
			.defaultNow(),
	},
	(t) => {
		return {
			authorityIdx: index('feature_flag_overrides_authority_idx').on(
				t.authority
			),
			authorityUnique: unique('feature_flag_overrides_authority_unique').on(
				t.authority
			),
		};
	}
);

export type FeatureFlagOverride = InferSelectModel<
	typeof feature_flag_overrides
>;
